(function () {
    'use strict';

    angular.module('asys')
        .controller('ReiterAbschlussController', ReiterAbschlussController);

    ReiterAbschlussController.$inject = [
        '$scope',
        '$window',
        '$injector',
        '$log',
        '$modalStack',
        '$analytics',
        'lodash',
        'modernizr',
        'AppConfig',
        'AngebotKfzService',
        'BasisAngebotService',
        'AngebotModel',
        'NavigationService',
        'MiscUtilsService',
        'AlertService',
        'IntegrationService',
        'AngebotUtilsService',
        'TrackingUtilsService',
        'LoadingIndicatorService'
    ];
    function ReiterAbschlussController($scope, $window, $injector, $log, $modalStack, $analytics, _, modernizr, AppConfig, AngebotKfzService, BasisAngebotService, AngebotModel, NavigationService, MiscUtilsService, AlertService, IntegrationService, AngebotUtilsService, TrackingUtilsService, LoadingIndicatorService) {
        var vm = this,
            angebotVm = $scope.angebotVm,
            angebotModel = _.cloneDeep(angebotVm.angebotModel),
            integrationParams = _.cloneDeep(IntegrationService.getIntegrationParams()),
            $localStorage;

        $localStorage = $injector.has('$localStorage') && $injector.get('$localStorage') || {};

        $log.debug('ReiterAbschlussController', vm);

        vm.isSuccessful = isSuccessful;
        vm.isGevo = isGevo;
        vm.neuesAngebotMitAntragsteller = neuesAngebotMitAntragsteller;

        activate();

        function activate() {
            angebotVm.cssClassMainActive = AppConfig.APP.cssClassMainWidthContainerSmall;
            vm.vertragsnummern = [];
            vm.status = 'SUCCESS';
            vm.isWaitOverlayOpened = false;

            vm.angebotModel = angebotModel;
            if (modernizr.sessionstorage) {
                $window.sessionStorage.removeItem('iframeReload');
                $window.sessionStorage.removeItem('reload');
            }

            if ($modalStack.getTop() && $modalStack.getTop().key) {
                $modalStack.getTop().key.reposition($modalStack.getTop().key);
            }

            if (isSuccessful()) {
                $window.onbeforeunload = null;

                if (angebotVm.isAppModus()) {
                    IntegrationService.sendMessage({
                        action: 'rateapp'
                    }, _.get($window, 'webkit.messageHandlers.cordova_iab'));
                }
                AngebotUtilsService.createVouchers(angebotModel.angebot).then(function (vouchers) {
                }).catch(function (error) {
                    $log.warn('Error in creating vouchers', error);
                });
            }

            AlertService.remove(_.map([
                'ANG_NICHT_AENDERBAR_ANGEBOT',
                'ANG_NICHT_AENDERBAR_ANTRAG'
            ], function (val) { return { id: val }; }));

            $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                var nachrichten,
                    pksNeuregistrierungNachricht;

                if (_.get($localStorage, 'redirectData.externalSid')) {
                    IntegrationService.setIntegrationParams({
                        externalSid: _.get($localStorage, 'redirectData.externalSid'),
                        externalPermissions: _.get($localStorage, 'redirectData.externalPermissions')
                    });
                }

                nachrichten = BasisAngebotService.filterNachrichten(toParams.apiNachrichten);

                _.forEach(nachrichten, function (nachricht) {
                    vm.vertragsnummern = AngebotUtilsService.getVertragsnummerFromApiNachricht(nachricht.meldung, true);

                    if (_.size(vm.vertragsnummern) > 0) {
                        return false;
                    }
                });

                vm.title = getAbschlussTitle();

                NavigationService.hideAll(true);

                pksNeuregistrierungNachricht = _.find(toParams.apiNachrichten, ['id', 'PKS_NEUREGISTRIERUNG_MOEGLICH']);

                vm.pksRegisterData = {
                    benutzername: _.get(angebotModel, 'formData.antragsteller.emailPrivat.wert'),
                    neukundeToken: _.get(pksNeuregistrierungNachricht, 'meldung') || integrationParams.neukundeToken || _.get($localStorage.redirectData, 'neukundeToken'),
                    partnernummer: _.get(angebotModel.angebot, 'antragsteller.partnernummer.id'),
                    angebotsnummer: BasisAngebotService.getAngebotsnummer(angebotModel.angebot),
                    angebotstoken: BasisAngebotService.getToken(angebotModel.angebot),
                    emailPrivat: _.get(angebotModel, 'formData.antragsteller.emailPrivat.wert'),
                    vertragsnummer: vm.vertragsnummern,
                    isVisible: !!pksNeuregistrierungNachricht && IntegrationService.hasPermission('ANG_PKS_REGISTRIEREN', integrationParams.externalPermissions)
                };
                if (MiscUtilsService.isNotEmpty(integrationParams.neukundeToken)) {
                    IntegrationService.setIntegrationParams({ neukundeToken: null });
                }

                if (_.find(nachrichten, ['kuerzel', 'WARTEN_VB_RUECKLAUF'])) {
                    vm.statusWartenVbRuecklauf = true;
                }

                if (_.find(nachrichten, ['kuerzel', 'WARTEN_ABMELDUNG'])) {
                    vm.statusWartenAbmeldung = true;
                }

                delete $localStorage.redirectData;
            });

            $scope.$on('$viewContentLoaded', function () {
                if ($modalStack.getTop() && $modalStack.getTop().key) {
                    $modalStack.getTop().key.reposition($modalStack.getTop().key);
                }

                if (isSuccessful()) {
                    AngebotModel.clear();
                    IntegrationService.removeIntegrationParams();
                }
            });
        }

        function isSuccessful() {
            return vm.status === 'SUCCESS';
        }
        function getAbschlussTitle() {
            return AngebotKfzService.getAbschlussTitle(angebotModel.angebot);
        }
        function isGevo(gevo) {
            return AngebotKfzService.isGevo(vm.angebotModel.angebot, gevo);
        }
        function neuesAngebotMitAntragsteller() {
            var startStep = BasisAngebotService.getStartStep(vm.angebotModel.angebot, true);

            LoadingIndicatorService.addInProgress();

            return BasisAngebotService.neuesAngebotMitAntragsteller(vm.angebotModel)
                .then(function (angebotModel) {
                    $scope.$emit('iplusjs:removeAllAlerts');
                    TrackingUtilsService.resetTrackingCache('wgv');

                    vm.angebotModel = angebotModel;

                    $analytics.setUserProperties({
                        hurra: {
                            orderId: AngebotUtilsService.getUid(vm.angebotModel)
                        }
                    });
                    NavigationService.setDisabled(startStep, false);
                    NavigationService.setFollowingDisabled(true, startStep);
                    NavigationService.goToStep(startStep, {
                        ignoreFollowingCheck: true
                    }, {
                        reload: true,
                        location: 'replace'
                    });
                }).catch(function (error) {
                    $log.error('BasisAngebotService.neuesAngebotMitAntragsteller FAILURE', error);
                }).finally(function () {
                    LoadingIndicatorService.removeInProgress();
                });
        }
    }

})();
